
import { useEffect } from 'react';
import { NoteType } from '../types/notes';

interface UseKeyboardShortcutsProps {
  onAddNote: (type: NoteType) => void;
  onDeleteNote: (nodeId: string) => void;
  onAnalyze: () => void;
  onQuickNote?: () => void;
}

export const useKeyboardShortcuts = ({ onAddNote, onDeleteNote, onAnalyze, onQuickNote }: UseKeyboardShortcutsProps) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Don't trigger shortcuts when typing in inputs
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      // Quick note shortcuts
      if (e.code === 'Space') {
        e.preventDefault();
        if (onQuickNote) {
          onQuickNote();
        } else {
          onAddNote('note');
        }
        return;
      }

      if (e.ctrlKey && e.code === 'Space') {
        e.preventDefault();
        if (onQuickNote) {
          onQuickNote();
        } else {
          onAddNote('note');
        }
        return;
      }

      // Regular note type shortcuts
      switch (e.key.toLowerCase()) {
        case 'n':
          e.preventDefault();
          onAddNote('note');
          break;
        case 'q':
          e.preventDefault();
          onAddNote('quote');
          break;
        case 'e':
          e.preventDefault();
          onAddNote('emotion');
          break;
        case 'b':
          e.preventDefault();
          onAddNote('behaviour');
          break;
        case 'p':
          e.preventDefault();
          onAddNote('pain');
          break;
        case 'i':
          e.preventDefault();
          onAddNote('insight');
          break;
        case 'o':
          e.preventDefault();
          onAddNote('opportunity');
          break;
        case 'r':
          e.preventDefault();
          onAnalyze();
          break;
      }

      if (e.key === 'Delete' || e.key === 'Backspace') {
        // In a real implementation, you'd get the selected node ID
        // For now, we'll just log the action
        console.log('Delete key pressed - would delete selected node');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onAddNote, onDeleteNote, onAnalyze, onQuickNote]);
};
